import React, { memo, useState } from 'react';
import { FilterRow } from '../../reportFilterModal.style';
import { DateRangePicker, FocusedInputShape } from 'react-dates';
import { useTranslation } from 'react-i18next';
import moment, { Moment } from 'moment';

interface Props {
    startDate: Date;
    endDate: Date;
    onDatesChange: ({
        startDate,
        endDate
    }: {
        startDate: Moment | null;
        endDate: Moment | null;
    }) => void;
}

const FilterDateRange = ({ startDate, endDate, onDatesChange }: Props) => {
    const { t } = useTranslation();
    const [focusedInput, setFocusedInput] = useState<FocusedInputShape | null>(null);

    return (
        <FilterRow>
            <label>{t('reportsFilterModal.dateRange')}</label>
            <div style={{ flex: 5 }}>
                <DateRangePicker
                    displayFormat="DD MMM YYYY"
                    hideKeyboardShortcutsPanel
                    transitionDuration={0}
                    daySize={34}
                    verticalSpacing={0}
                    minimumNights={0}
                    startDateId="startDate"
                    endDateId="endDate"
                    isOutsideRange={() => false}
                    startDate={startDate && moment(startDate)}
                    endDate={endDate && moment(endDate)}
                    onDatesChange={onDatesChange}
                    focusedInput={focusedInput}
                    onFocusChange={(it) => setFocusedInput(it)}
                    keepOpenOnDateSelect={false}
                    numberOfMonths={1}
                    isDayHighlighted={(day) => day.isSame(new Date(), 'day')}
                />
            </div>
        </FilterRow>
    );
};

export default memo(FilterDateRange);
